import React, { useContext } from 'react';
import { OrdersGlobalContext } from '@mummssoftware/global-context/OrdersGlobalContext';
import TagComponent from './TagComponent';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import { Context } from '../../context';

import { TagNoteDiv } from '../../components/layout/WrapperDiv';

type TagNoteProps = {
  note: any | null;
};

// This accommodates the 2 scenarios, PN posted and not posted and the 3 checkboxes
const TagNote = ({ note }: TagNoteProps) => {
  const { orderCreated } = useContext(ProgressNotesContext);
  const { orderType } = useContext(OrdersGlobalContext);
  const { entityKey } = useContext(Context);
  // cannot tag a note of O&N is opened from another widget
  const disabled = (!!orderType && !orderCreated) || !!entityKey;
  return (
    <TagNoteDiv id="checkbox-content">
      <TagComponent note={note} disabled={disabled} saveInitialNote />
    </TagNoteDiv>
  );
};

export default TagNote;
